export enum GricsImportStatus {
  Queued = 'queued',
  Processing = 'processing',
  Completed = 'completed',
  Incomplete = 'incomplete',
  Interrupted = 'interrupted',
  Error = 'error',
}
